import { Configuration } from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_ENV_B2C_CLIENT_ID!,
        authority: process.env.REACT_APP_ENV_B2C_AUTHORITY!.replace(/\/$/, ""),
    knownAuthorities: [process.env.REACT_APP_ENV_B2C_KNOWN_AUTHORITY!],
    redirectUri: process.env.REACT_APP_ENV_B2C_REDIRECT_URI,
    postLogoutRedirectUri: process.env.REACT_APP_ENV_B2C_REDIRECT_URI
  },
  cache: {
    cacheLocation: "localStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO.
    storeAuthStateInCookie: false,
  },
};

export const apiRequest = {
  scopes: [process.env.REACT_APP_ENV_B2C_SCOPE_API!]
};
